export default __webpack_public_path__ + "static/media/create-a-project.528a69ac.svg";